// extracted by mini-css-extract-plugin
export default {"emptyCartBlock":"EmptyCart_emptyCartBlock__5Z3JV","imgContainer":"EmptyCart_imgContainer__3y3gQ","backShopBtn":"EmptyCart_backShopBtn__O9ENc"};